export enum MountPoints {
  body = 'body',
  root = 'root',
}
